var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "32793677-7376-4E7B-8426-EAD9261617E1")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Homepage",
    transform: "translate(-746.000000, -12.000000)",
    fill: "#FFC62B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info_Top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Middle_InfoTop",
    transform: "translate(387.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stars_Rating",
    transform: "translate(359.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "start",
    points: "9.4644998 11.0859998 7.83149984 6.79649986 11.2239998 4.25499991 7.17599985 4.25499991 5.61199988 1.8793855e-13 4.03649992 4.25499991 0 4.25499991 3.39249993 6.79649986 1.75949996 11.0859998 5.61199988 8.19949983"
  }))))))));
};
export default SvgStar;